

















import WarehousePatchForm, { WarehousePatchFormObject } from '@/components/WarehousePatch/WarehousePatchForm.vue';
import { linesToSave } from '@/app/WarehousePatch';
import dayjs from 'dayjs';
import { Component, Vue } from 'vue-property-decorator';
import { CREATE_WAREHOUSE_PATCH } from '@/queries/WarehousePatch';
import { SmartQuery } from 'vue-apollo-decorator';
import { CURRENT_UNIT } from '@/queries/Application';
import { GQL_currentUnit, GQL_currentUnit_currentUnit } from '@/queries/__generated__/currentUnit';
import { GQL_createWarehousePatch, GQL_createWarehousePatchVariables } from '@/queries/__generated__/createWarehousePatch';

@Component({
  components: {
    WarehousePatchForm,
  },
})
export default class WarehousePatchNew extends Vue {
  @SmartQuery<WarehousePatchNew, GQL_currentUnit>({
    query: CURRENT_UNIT,
    result({ data }) {
       this.data =  {
          id: null,
          unitId: data.currentUnit.id,
          date: dayjs().format('YYYY-MM-DD').toString(),
          supplierUnitId: null,
          supplierUnitName: null,
          warehousePatchLines: [],
          comment: null,
          createdAt: null,
          createdBy: null,
        };
      },
}) private currentUnit!: GQL_currentUnit_currentUnit;

  private data: WarehousePatchFormObject | null = null

  public CREATE_WAREHOUSE_PATCH = CREATE_WAREHOUSE_PATCH;

  public formatDataForMutation(warehousePatch: WarehousePatchFormObject): GQL_createWarehousePatchVariables {
    return {
      warehousePatch: {
        unitId: warehousePatch.unitId,
        date: warehousePatch.date,
        supplierUnitId: warehousePatch.supplierUnitId,
        comment: warehousePatch.comment,
        warehousePatchLines: linesToSave(warehousePatch.warehousePatchLines).map(line => {
          return {
            productId: line.productId,
            quantity: line.quantity,
            purchasePrice: line.purchasePrice,
            productName: line.productName,
            productNumber: line.productNumber,
            checkpoint: line.checkpoint,
          };
        }),
      },
    };
  }

  private onCreate(data: GQL_createWarehousePatch) {
    if (!data.createWarehousePatch || !data.createWarehousePatch.warehousePatch) return;

    this.$router.push({
      name: 'WarehousePatchEdit',
      params: { id: String(data.createWarehousePatch.warehousePatch.id) },
    });
  }
}
